/* Reya · SEO content "Read more" — progressive enhancement; the full text always stays in the DOM. */
if (!customElements.get('rr-seo-content')) {
  customElements.define(
    'rr-seo-content',
    class extends HTMLElement {
      connectedCallback() {
        this.body = this.querySelector('[data-rr-seo-body]');
        this.btn = this.querySelector('[data-rr-seo-toggle]');
        this.label = this.querySelector('[data-rr-seo-label]');
        if (!this.body || !this.btn) return;
        const raw = parseFloat(getComputedStyle(this).getPropertyValue('--rr-collapsed'));
        const limit = Number.isNaN(raw) ? 180 : raw;
        if (this.body.scrollHeight <= limit + 48) return;
        this.classList.add('is-collapsible');
        this.btn.hidden = false;
        this.set(false);
        this.btn.addEventListener('click', () => this.set(this.btn.getAttribute('aria-expanded') !== 'true'));
        // Expand if keyboard focus lands on a link inside the clipped text.
        this.body.addEventListener('focusin', () => this.set(true));
      }
      set(open) {
        this.classList.toggle('is-collapsed', !open);
        this.body.style.maxHeight = open ? this.body.scrollHeight + 'px' : '';
        this.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (this.label) this.label.textContent = open ? this.dataset.less : this.dataset.more;
      }
    }
  );
}
